const style = (theme) => {
  const output = {
    root: {
      // height: '100vh',
      // paddingTop: (props) => (props.headerHeight + 40),
      // paddingBottom: 40,
    },
    grid: {
      extend: theme.wrapper,
      display: 'flex',
      height: '100vh',
      paddingTop: (props) => (props.headerHeight + 40),
      paddingBottom: 40,
    },
    gridBetween: {
      justifyContent: 'space-between',
    },
    gridImage: {
      width: '56%',
      marginLeft: 40,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& img': {
        zIndex: 1,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        fontFamily: "'object-fit: contain;'",
      },
    },
    gridContent: {
      position: 'relative',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
    gridContentMain: {
      position: 'relative',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      paddingTop: 40,
    },
    gridContentMainContainer: {
      width: '100%',
      height: '100%',
      display: 'table',
    },
    gridContentMainTable: {
      position: 'relative',
      display: 'table-cell',
      verticalAlign: 'middle',
    },
    designer: {
      fontWeight: 300,
      textTransform: 'uppercase',
      fontSize: 14,
      marginBottom: 10,
    },
    title: {
      fontFamily: theme.fonts[2],
      textTransform: 'uppercase',
      fontSize: 60,
      position: 'relative',
      lineHeight: 1,
      marginBottom: 30,
      display: 'inline-block',
      '&::after': {
        content: '""',
        position: 'absolute',
        height: 1,
        width: '100%',
        bottom: 0,
        left: 0,
        background: theme.getRgba(theme.colors[2], 0.4),
      },
    },
    desc: {
      fontWeight: 400,
      fontSize: 16,
      marginBottom: 40,
      width: '70%',
      '& p:not(:last-child)': {
        marginBottom: 40,
      },
    },
    price: {
      fontWeight: 600,
      fontSize: 18,
      marginTop: 40,
    },
    discountPrice: {
      marginLeft: 10,
      textDecoration: 'line-through',
    },
    btnControls: {
      display: 'flex',
      marginTop: 40,
      flexDirection: 'column',
      alignItems: 'flex-start',
      '& > *:not(:last-child)': {
        marginBottom: 30,
      },
      '& > span': {
        fontSize: 12,
        letterSpacing: 1,
        textTransform: 'uppercase',
      },
    },
    controls: {},
    products: {
      marginTop: 150,
      marginBottom: 150,
      extend: theme.wrapper,
      '& h3': {
        fontSize: 35,
        marginBottom: 30,
      },
    },
    productView: {
      display: 'flex',
      flexFlow: 'row wrap',
      justifyContent: 'flex-start',
      marginLeft: -30,
      marginRight: -30,
      '& .productItem__root': {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 58,
        width: 'calc(100% / 4)',
        padding: '0 30px',
      },
      '& .productItem__image': {
        paddingBottom: '100%',
      },
      '& .productItem__desc': {
        paddingTop: 20,
      },
    },
    btnCta: {
      marginRight: 10,
    },
    notAvailable: {
      opacity: 0.4,
      pointerEvents: 'none',
    },
    preorder: {
      fontSize: 11,
      letterSpacing: 1,
      textTransform: 'uppercase',
      display: 'inline-block',
      margin: [10, 0],
      padding: '5px 12px',
      background: theme.colors[5],
      borderRadius: 5,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      height: 'auto',
    },
    grid: {
      height: 'auto',
      flexDirection: 'column',
      marginTop: 0,
    },
    gridImage: {
      marginLeft: 0,
      width: '100%',
    },
    gridContent: {
      marginBottom: 40,
    },
    gridContentMain: {
      position: 'relative',
    },
    title: {
      fontSize: 45,
    },
    desc: {
      width: '100%',
    },
    btnControls: {
      alignItems: 'center',
      '& > *:not(:last-child)': {
        marginBottom: 30,
      },
    },
    products: {
      marginTop: 50,
      marginBottom: 0,
      '& h3': {
        fontSize: 25,
        marginBottom: 25,
      },
    },
    productView: {
      marginLeft: 0,
      marginRight: 0,
      '& .productItem__root': {
        marginBottom: 45,
        width: '100%',
        padding: 0,
      },
    },
  }

  return output
}

export default style
